import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CourierService } from './../../../shared/services/courier.service';
import { GetRegionRequest, GetRegionResponse, GetRoutesRequest, GetRoutesResponse } from './../../../shared/models/courier.models';
import { ActiveUserLocalDataService } from './../../../shared/services/active-user-local-data.service';
import { StartNewVoucherDataClass } from './../../../shared/models/start-new-voucher-data.model';

@Component({
  templateUrl: 'pick-region.component.html',
  styleUrls: ['./pick-region.component.scss']
})
export class PickRegionComponent implements OnInit {

  regionResponse: GetRegionResponse | null = null;
  routeResponse: GetRoutesResponse | null = null;
  loading: boolean = true;

  constructor(
    private courierService: CourierService,
    private activeUserLocalDataService: ActiveUserLocalDataService,
    private router: Router
  ) {}

  ngOnInit() {
    const startNewVoucherData = this.activeUserLocalDataService.getStartNewVoucherData();
    if (!startNewVoucherData) {
      this.router.navigate(['/pick-car']);
      return;
    }
    this.loadRegionList();
  }

  loadRegionList() {
    const startNewVoucherData = this.activeUserLocalDataService.getStartNewVoucherData();
    const request: GetRegionRequest = { clientId: startNewVoucherData?.clientId };
    this.courierService.getRegionValue(request).subscribe((response: GetRegionResponse) => {
      this.regionResponse = response;
      this.loading = false;
    });
  }

  continueNextStep(regionId: number | undefined) {
    const startNewVoucherData = this.activeUserLocalDataService.getStartNewVoucherData();
    if (startNewVoucherData) {
      startNewVoucherData.regionId = regionId;
      const routeRequest: GetRoutesRequest = { clientId: startNewVoucherData.clientId, regionId };
      this.courierService.getRoute(routeRequest).subscribe(routeResponse => {
        this.routeResponse = routeResponse;
        if (routeResponse.routes?.length > 0) {
          this.router.navigate(['/pick-route']);
        } else {
          this.router.navigate(['/input-odometer']);
        }
      });
    }
  }

  navigateToPickClient() {
    this.router.navigate(['/pick-client']);
  }
}